import React from "react";
import { FieldArray } from "formik";
import InputField from "../../forms/input-field";
import ImageField from "../../forms/images-field";

const emptyPartner = {
  partner_name: "",
  partner_relation_with: "",
  partner_age: "",
  partner_pincode: "",
  partner_area: "",
  partner_city: "",
  partner_state: "",
  partner_full_address: "",
  partner_landmark: "",
  partner_town_or_village: "",
  partner_aadhar_number: "",
  partner_aadhar_front: "",
  partner_aadhar_back: "",
};

const StorePartnerDetailsTab = ({ disabled = false }) => {
  return (
    <FieldArray name="partners">
      {({ form, push, remove }) => (
        <div className="w-full 2xl:w-[40%] xl:w-[50%] lg:w-[60%] px-5 xl:px-10 mt-5">
          {form.values.partners?.map((_, index) => (
            <div key={index} className="mb-6 border border-D0D5DD rounded-lg p-4">
              <div className="flex justify-between items-center mb-3">
                <span className="text-sm font-semibold text-gray-600">
                  Partner {index + 1}
                </span>
                {!disabled && form.values.partners.length > 1 && (
                  <button
                    type="button"
                    onClick={() => remove(index)}
                    className="text-sm text-red-500 hover:text-red-700"
                  >
                    Remove
                  </button>
                )}
              </div>
              <InputField
                isDisabled={disabled}
                type="text"
                name={`partners[${index}].partner_name`}
                placeholder="Enter Partner Name"
                label="Partner Name"
                labelWidth="10.5rem"
              />
              <InputField
                isDisabled={disabled}
                type="text"
                name={`partners[${index}].partner_relation_with`}
                placeholder="Enter Relation With"
                label="Relation With"
                labelWidth="10.5rem"
              />
              <InputField
                isDisabled={disabled}
                type="number"
                name={`partners[${index}].partner_age`}
                placeholder="Enter Age"
                label="Age"
                labelWidth="10.5rem"
              />
              <InputField
                isDisabled={disabled}
                type="text"
                name={`partners[${index}].partner_pincode`}
                placeholder="Enter Pincode"
                label="Pincode"
                labelWidth="10.5rem"
              />
              <InputField
                isDisabled={disabled}
                type="text"
                name={`partners[${index}].partner_area`}
                placeholder="Enter Area"
                label="Area"
                labelWidth="10.5rem"
              />
              <InputField
                isDisabled={disabled}
                type="text"
                name={`partners[${index}].partner_city`}
                placeholder="Enter City"
                label="City"
                labelWidth="10.5rem"
              />
              <InputField
                isDisabled={disabled}
                type="text"
                name={`partners[${index}].partner_state`}
                placeholder="Enter State"
                label="State"
                labelWidth="10.5rem"
              />
              <InputField
                isDisabled={disabled}
                type="text"
                name={`partners[${index}].partner_full_address`}
                placeholder="Enter Full Address"
                label="Full Address"
                labelWidth="10.5rem"
              />
              <InputField
                isDisabled={disabled}
                type="text"
                name={`partners[${index}].partner_landmark`}
                placeholder="Enter Landmark"
                label="Landmark"
                labelWidth="10.5rem"
              />
              <InputField
                isDisabled={disabled}
                type="text"
                name={`partners[${index}].partner_town_or_village`}
                placeholder="Enter Town / Village"
                label="Town / Village"
                labelWidth="10.5rem"
              />
              <InputField
                isDisabled={disabled}
                type="text"
                name={`partners[${index}].partner_aadhar_number`}
                placeholder="Enter Aadhaar Number"
                label="Aadhaar Number"
                labelWidth="10.5rem"
              />
              <ImageField
                isDisabled={disabled}
                label="Aadhaar Front"
                labelWidth="10.5rem"
                name={`partners[${index}].partner_aadhar_front`}
              />
              <ImageField
                isDisabled={disabled}
                label="Aadhaar Back"
                labelWidth="10.5rem"
                name={`partners[${index}].partner_aadhar_back`}
              />
            </div>
          ))}
          {!disabled && (
            <button
              type="button"
              onClick={() => push({ ...emptyPartner })}
              className="mt-2 px-4 py-2 text-sm rounded-md border border-027A48 text-027A48 hover:bg-green-50"
            >
              + Add Partner
            </button>
          )}
        </div>
      )}
    </FieldArray>
  );
};

export default StorePartnerDetailsTab;